import CircularProgress from "@mui/material/CircularProgress";
import styled from "styled-components";
import { useAppSelector } from "../../app/hooks";
import { loadingState } from "../../app/reducers/loading-slice";
import theme from "../../style/theme";

export const ProgressLoading = () => {
  const { globalLoading, isDim } = useAppSelector(loadingState);

  return (
    <>
      {globalLoading ? (
        <Container
          isDim={isDim}>
          <CircularProgress
            sx={{ color: theme.palette.primitives.yellow400 }}
          />
        </Container>
      ) : null}
    </>
  );
};

const Container = styled.div<{
  isDim: boolean,
}>`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  z-index: 99999999;
  justify-content: center;
  align-items: center;
  background: ${({ isDim }) => isDim ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0)"}
`;
